import React from "react";
import { Card } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
const CommonCard = (props) => {

  const deleteCard = () => {
    //alert("Please delete your card");
    props.deleteHandler({ type: props.type, id: props.id });
  };

  return (
    <Card hoverable={props.hoverable} style={{}}>
      <div  style={{
        display:'flex',
        justifyContent:'flex-end'
      }}>
        {props.deleteIcon && <DeleteOutlined onClick={props.deleteIcon} />}
      </div>
      <div className="cardHeader d-flex">
        {props.name && <h5 className="text-overflow">{props.name}</h5>}

        {/* <EditOutlined onClick={editCard} />
        <DeleteOutlined onClick={deleteCard} /> */}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {props.phoneNumber && (
          <span className="text-overflow">{props.phoneNumber}</span>
        )}
        {props.email && <span className="text-overflow">{props.email}</span>}
        {props.designation && (
          <span className="text-overflow">{props.designation}</span>
        )}
        <span>
          {props.country && (
            <span className="text-overflow"> {props.country} </span>
          )}
          {props.stateOrProvince && (
            <span className="text-overflow"> {props.stateOrProvince}</span>
          )}
        </span>
        {props.addressLine1 && (
          <span className="text-overflow">{props.addressLine1}</span>
        )}
        {props.addressLine2 && (
          <span className="text-overflow">{props.addressLine2}</span>
        )}
        {props.brandCode && (
          <h5 className="text-overflow">{props.brandCode}</h5>
        )}
        {props.brandName && (
          <span className="text-overflow">{props.brandName}</span>
        )}
        {props.tracking && (
          <span className="text-overflow">{props.tracking}</span>
        )}
        {props.reference && (
          <span className="text-overflow">{props.reference}</span>
        )}
        <span className="text-overflow">{props.contactPerson}</span>
      </div>
    </Card>
  );
};

export default CommonCard;
